import React, { useState, useEffect, useRef } from "react";
import "./styles.scss";
import HeadDescription from "../../component/checkout/headDescription";
import ContactUsInfo from "../../component/checkout/contactUsInfo";
import ShippingInfo from "../../component/checkout/shippingInfo";
import OrderSummaryInfo from "../../component/checkout/orderSummary";
import { FormControlLabel, Checkbox, Button } from "@mui/material";

import Box from "@mui/material/Box";
import Stepper from "@mui/material/Stepper";
import Step from "@mui/material/Step";
import Typography from "@mui/material/Typography";

import { styled } from "@mui/material/styles";
import PropTypes from "prop-types";
import StepLabel from "@mui/material/StepLabel";
import StepConnector, {
  stepConnectorClasses,
} from "@mui/material/StepConnector";
import { useStateValue } from "../../store";
import {
  getOrderSummary,
  getContactInfo,
  getShippingAddressInfo,
  getPayentInitialization,
  getCountryList,
  getStateList,
  getShippingMethod,
  getBillingAddressInfo,
  postKalvioEmail,
} from "../../store/homeAction/action";
import StripPayment from "../../component/checkout/paymentInfo/stripPayment";
import BillingInfo from "../../component/checkout/billingInfo";

import { ReactComponent as FilledIcon } from "../../assets/icons/tick_filled.svg";
import { ReactComponent as UnFilledIcon } from "../../assets/icons/tick_unfilled.svg";
import { ReactComponent as FilledCheckIcon } from "../../assets/icons/filledCheckbox.svg";
import { ReactComponent as UnFilledCheckIcon } from "../../assets/icons/unfilledCheckbox.svg";
import { ReactComponent as ActiveFilledIcon } from "../../assets/icons/Icons.svg";
import { ReactComponent as TickIcon } from "../../assets/icons/Vector.svg";
import SkeletonLine from "../../common/Skeletion/line";

const steps = ["Contact info", "Shipping address", "Payment"];

const Checkout = () => {
  const activeStep = useRef(0);
  const [completed, setCompleted] = useState({});
  const [handleSubmitCall, setHandleSubmitCall] = useState(false);
  const [expanded, setExpanded] = useState("panel1");
  const [
    {
      checkoutData,
      countryList,
      checkoutPayment,
      checkoutOrderSummary,
      billingResponseData,
      servicePopup,
    },
    dispatch,
  ] = useStateValue();
  const [contactData, setContactData] = useState("");
  const [inputValidation, setInputValidation] = useState({
    billing_first_name: "",
    billing_last_name: "",
    billing_phone_number: "",
    billing_address_1: "",
    billing_address_2: "",
    billing_postal_zip: "",
    billing_city: "",
    billing_country: "",
    billing_state: "",
  });
  const [emailValidation, setEmailValidation] = useState("");
  const [billedCheckbox, setBilledCheckbox] = useState(true);
  const [postalCodeValid, setPostalCodeValid] = useState(null);
  const initialShipping = {
    shipping_first_name: "",
    shipping_last_name: "",
    shipping_phone_number: "",
    shipping_company_name: "",
    shipping_address_1: "",
    shipping_address_2: "",
    shipping_postal_zip: "",
    shipping_city: "",
    shipping_country: "",
    shipping_state: "",
  };
  const initialBilling = {
    billing_first_name: "",
    billing_last_name: "",
    billing_phone_number: "",
    billing_company_name: "",
    billing_address_1: "",
    billing_address_2: "",
    billing_postal_zip: "",
    billing_city: "",
    billing_country: "",
    billing_state: "",
  };
  const [shippingData, setShippingData] = useState(initialShipping);
  const [billingData, setBillingData] = useState(initialBilling);
  const [statetrigger, setStateTrigger] = useState(false);
  const [billingStatetrigger, setBillingStateTrigger] = useState(false);
  const [loading, setLoading] = useState(false);
  const handleUpdateContactForm = () => {
    dispatch({
      type: "SET_IS_LOADING",
      value: true,
    });
    const mail = sessionStorage.getItem("mail_checkout");
    let payload = {
      session_key: sessionStorage.getItem("session_key"),
      email: contactData ? contactData : mail,
    };
    // setShippingData(initialShipping);
    getContactInfo((res) => {
      if (res?.status) {
        dispatch({
          type: "SET_CHECKOUT_DATA",
          data: { ...checkoutData, ...res?.data },
        });
        if (res?.data?.email) {
          sessionStorage.setItem("mail_checkout", res?.data?.email);
          setContactData(res?.data?.email);
          // if (!checkoutData?.shipping_first_name) {
          setExpanded("panel2");
          handleComplete(1);
          handleUpdateShippingAddress("email_changed");
          // } else {
          //   setExpanded("panel3");
          //   handleUpdatePayment();
          // }
        } else {
          setExpanded("panel1");
        }
      } else if (!res?.status) {
        setEmailValidation(res?.message);
      } else {
        dispatch({
          type: "SET_ALERT_MESSAGE",
          value: true,
          data: {
            severity: "error",
            message: "Something went wrong, Please try again.",
          },
        });
      }
      dispatch({
        type: "SET_IS_LOADING",
        value: false,
      });
    }, payload);
    const contact = contactData || mail;
    if (contact) {
      postKalvioEmail((res, error) => {}, contactData ? contactData : mail);
    }
  };
  const handleUpdateShippingAddress = (is_email_changed) => {
    setPostalCodeValid(null);
    const mail = sessionStorage.getItem("mail_checkout");
    let payload;
    if (is_email_changed === "email_changed") {
      payload = {
        email: contactData ? contactData : mail ? mail : "",
        session_key: sessionStorage.getItem("session_key"),
        shipping_first_name: "",
        shipping_last_name: "",
        shipping_phone_number: "",
        shipping_company_name: "",
        shipping_address_1: "",
        shipping_address_2: "",
        shipping_postal_zip: "",
        shipping_city: "",
        shipping_country: "",
        shipping_state: "",
        service: null,
      };
    } else {
      payload = {
        email: contactData ? contactData : mail ? mail : "",
        session_key: sessionStorage.getItem("session_key"),
        shipping_first_name: shippingData?.shipping_first_name,
        shipping_last_name: shippingData?.shipping_last_name,
        shipping_phone_number: shippingData?.shipping_phone_number,
        shipping_company_name: shippingData?.shipping_company_name,
        shipping_address_1: shippingData?.shipping_address_1,
        shipping_address_2: shippingData?.shipping_address_2,
        shipping_postal_zip: shippingData?.shipping_postal_zip,
        shipping_city: shippingData?.shipping_city,
        shipping_country: shippingData?.shipping_country?.country_id
          ? shippingData?.shipping_country?.country_id
          : null,
        shipping_state: shippingData?.shipping_state?.state_id
          ? shippingData?.shipping_state?.state_id
          : shippingData?.shipping_state
          ? shippingData?.shipping_state
          : null,
        service: servicePopup?.data !== null ? servicePopup?.data : null,
      };
    }
    dispatch({
      type: "SET_IS_LOADING",
      value: true,
    });
    getShippingAddressInfo((res, error) => {
      if (error === undefined) {
        dispatch({
          type: "SET_CHECKOUT_DATA",
          data: {
            ...checkoutData,
            ...res?.data,
          },
        });
        if (servicePopup?.data !== null && servicePopup?.data !== undefined) {
          handleOrderSummary();
        }
        if (res?.data?.shipping_first_name) {
          setExpanded("panel3");
          setShippingData({
            ...res?.data,
          });
          handleComplete(2);
          handleUpdatePayment();
          // handleUpdateBilling();
        } else {
          setShippingData((prev) => ({
            ...res?.data,
            shipping_postal_zip: res?.data?.shipping_postal_zip,
          }));
          setExpanded("panel2");
        }
      } else {
        if (error?.is_service_available) {
          dispatch({
            type: "SET_IS_SERVICE_POPUP",
            value: true,
            data: null,
            apiData: error?.message,
          });
        } else {
          setPostalCodeValid(error?.message);
          document.getElementById("postal-code-isvalid")?.focus();
        }
      }
      dispatch({
        type: "SET_IS_LOADING",
        value: false,
      });
    }, payload);
  };

  useEffect(() => {
    if (countryList?.length && Object.keys(checkoutData).length !== 0) {
      let country;
      country =
        countryList?.length &&
        countryList?.filter(
          (item) => item?.country_id === checkoutData?.shipping_country
        );
      setShippingData((prev) => ({
        ...prev,
        shipping_country: country?.[0],
      }));
    }
  }, [countryList, checkoutData]);

  const handleOrderSummary = () => {
    const mail = sessionStorage.getItem("mail_checkout");
    let payload = {
      email: mail,
      session_key: sessionStorage.getItem("session_key"),
    };
    getOrderSummary((res) => {
      dispatch({
        type: "SET_CHECKOUT_ORDER_SUMMARY",
        data: {
          ...res?.data,
        },
      });
    }, payload);
  };

  const handleUpdatePayment = () => {
    const mail = sessionStorage.getItem("mail_checkout");
    let payload = {
      email: mail,
      session_key: sessionStorage.getItem("session_key"),
    };
    setLoading(true);
    getPayentInitialization((res) => {
      sessionStorage.setItem("order_id", res?.order_id);
      dispatch({
        type: "SET_CHECKOUT_PAYMENT",
        data: {
          ...res,
        },
      });
      setLoading(false);
    }, payload);
  };

  useEffect(() => {
    handleOrderSummary();
    handleUpdateContactForm();
    getCountryList((res) => {
      dispatch({
        type: "SET_CHECKOUT_COUNTRY",
        data: res,
      });
    });
  }, []);

  useEffect(() => {
    if (servicePopup?.data !== null && servicePopup?.data !== undefined) {
      handleUpdateShippingAddress();
    }
  }, [servicePopup?.data]);
  useEffect(() => {
    if (countryList?.length && shippingData?.shipping_country?.country_id) {
      const mail = sessionStorage.getItem("mail_checkout");
      let payload = {
        email: mail,
        session_key: sessionStorage.getItem("session_key"),
        shipping_selected_country: shippingData?.shipping_country?.country_id,
        shipping_selected_state: null,
      };
      setStateTrigger(true);
      getStateList((res) => {
        dispatch({
          type: "SET_CHECKOUT_STATE",
          data: res,
        });
        setStateTrigger(false);
        let state;
        state =
          res?.data?.states?.length &&
          res?.data?.states?.filter(
            (item) => item?.state_id === checkoutData?.shipping_state
          );
        setShippingData((prev) => ({
          ...prev,
          shipping_state: state?.[0],
        }));
      }, payload);
    }
  }, [shippingData?.shipping_country]);

  useEffect(() => {
    if (
      (countryList?.length && shippingData?.shipping_country?.country_id) ||
      shippingData?.shipping_state?.state_id ||
      shippingData?.shipping_state
    ) {
      const mail = sessionStorage.getItem("mail_checkout");
      let payload = {
        email: mail,
        session_key: sessionStorage.getItem("session_key"),
        shipping_selected_country: shippingData?.shipping_country?.country_id,
        shipping_selected_state: shippingData?.shipping_state?.state_id
          ? shippingData?.shipping_state?.state_id
          : shippingData?.shipping_state
          ? shippingData?.shipping_state
          : null,
      };
      getShippingMethod((res) => {
        dispatch({
          type: "SET_CHECKOUT_SHIPPING_METHOD",
          data: res,
        });
        handleOrderSummary();
      }, payload);
    }
  }, [shippingData?.shipping_state, shippingData?.shipping_country]);

  const handleComplete = (level) => {
    const objectLength = Object.keys(completed)?.length;
    if (objectLength < 2) {
      const newCompleted = completed;
      completed[activeStep.current] = true;
      setCompleted(newCompleted);
      activeStep.current = level;
    }
  };

  const handleChange = (panel) => {
    setExpanded(panel);
  };

  const QontoConnector = styled(StepConnector)(({ theme }) => ({
    [`&.${stepConnectorClasses.alternativeLabel}`]: {
      top: 10,
      left: "calc(-50% + 16px)",
      right: "calc(50% + 16px)",
    },
    [`&.${stepConnectorClasses.active}`]: {
      [`& .${stepConnectorClasses.line}`]: {
        borderColor: "#D25333",
      },
    },
    [`&.${stepConnectorClasses.completed}`]: {
      [`& .${stepConnectorClasses.line}`]: {
        borderColor: "#D25333",
      },
    },
    [`& .${stepConnectorClasses.line}`]: {
      borderColor:
        theme.palette.mode === "dark" ? theme.palette.grey[800] : "#eaeaf0",
      borderTopWidth: 3,
      borderRadius: 1,
    },
  }));

  const QontoStepIconRoot = styled("div")(({ theme, ownerState }) => ({
    color: theme.palette.mode === "dark" ? theme.palette.grey[700] : "#D25333",
    display: "flex",
    height: 22,
    alignItems: "center",
    ...(ownerState.active && {
      color: "#D25333",
    }),
  }));

  function QontoStepIcon(props) {
    const { active, completed, className } = props;
    return (
      <QontoStepIconRoot ownerState={{ active }} className={className}>
        {active ? (
          <ActiveFilledIcon />
        ) : completed ? (
          <FilledIcon />
        ) : (
          <UnFilledIcon />
        )}
      </QontoStepIconRoot>
    );
  }
  QontoStepIcon.propTypes = {
    /**
     * Whether this step is active.
     * @default false
     */
    active: PropTypes.bool,
    className: PropTypes.string,
    /**
     * Mark the step as completed. Is passed to child components.
     * @default false
     */
    completed: PropTypes.bool,
  };

  const handleCallSubmit = () => {
    setHandleSubmitCall(true);
  };

  const handleUpdateBilling = () => {
    setPostalCodeValid(null);
    const mail = sessionStorage.getItem("mail_checkout");
    let data1 = {
      email: mail,
      session_key: sessionStorage.getItem("session_key"),
      billing_first_name: null,
      billing_last_name: null,
      billing_phone_number: null,
      billing_company_name: null,
      billing_address_1: null,
      billing_address_2: null,
      billing_postal_zip: null,
      billing_city: null,
      billing_country: null,
      billing_state: null,
      billing: false,
    };

    let data2 = {
      email: mail,
      session_key: sessionStorage.getItem("session_key"),
      billing_first_name: billingData?.billing_first_name,
      billing_last_name: billingData?.billing_last_name,
      billing_phone_number: billingData?.billing_phone_number,
      billing_company_name: billingData?.billing_company_name,
      billing_address_1: billingData?.billing_address_1,
      billing_address_2: billingData?.billing_address_2,
      billing_postal_zip: billingData?.billing_postal_zip,
      billing_city: billingData?.billing_city,
      billing_country: billingData?.billing_country?.country_id
        ? billingData?.billing_country?.country_id
        : null,
      billing_state: billingData?.billing_state?.state_id
        ? billingData?.billing_state?.state_id
        : billingData?.billing_state
        ? billingData?.billing_state
        : null,
      billing: true,
    };
    let payload = !billedCheckbox ? data2 : data1;
    dispatch({
      type: "SET_IS_LOADING",
      value: true,
    });
    getBillingAddressInfo((res, error) => {
      if (error === undefined) {
        dispatch({
          type: "SET_CHECKOUT_BILLING_DATA",
          data: {
            ...res?.data,
          },
        });
        handleCallSubmit();
        let country;
        country =
          countryList?.length &&
          countryList?.filter(
            (item) => item?.country_id === res?.data?.billing_country
          );
        setBillingData({
          ...billingData,
          ...res?.data,
          billing_country: country?.[0],
        });
      } else {
        setPostalCodeValid(error?.message);
        document.getElementById("postal-code-isvalid")?.focus();
      }
      dispatch({
        type: "SET_IS_LOADING",
        value: false,
      });
    }, payload);
  };

  useEffect(() => {
    if (countryList?.length && billingResponseData?.billing_country) {
      let country;
      country =
        countryList?.length &&
        countryList?.filter(
          (item) => item?.country_id === billingResponseData?.billing_country
        );
      setBillingData((prev) => ({
        ...prev,
        billing_country: country?.[0],
      }));
    }
  }, [countryList, billingResponseData?.billing_country]);

  // validation
  const handleValidateInput = () => {
    if (billedCheckbox) {
      handleCallSubmit();
    } else {
      var errorHandle = false;
      if (!billingData?.billing_first_name) {
        document.getElementById("billing_first_name")?.focus();
        setInputValidation((prevState) => ({
          ...prevState,
          billing_first_name: "Please enter the first name.",
        }));
        errorHandle = true;
      }
      if (!billingData?.billing_last_name) {
        document.getElementById("billing_last_name")?.focus();
        setInputValidation((prevState) => ({
          ...prevState,
          billing_last_name: "Please enter the last name.",
        }));
        errorHandle = true;
      }
      if (!billingData?.billing_phone_number) {
        document.getElementById("billing_phone_number")?.focus();
        setInputValidation((prevState) => ({
          ...prevState,
          billing_phone_number: "Please enter the phone number.",
        }));
        errorHandle = true;
      } else if (
        billingData?.billing_phone_number?.length < 6 ||
        billingData?.billing_phone_number?.length > 15
      ) {
        document.getElementById("billing_phone_number")?.focus();
        setInputValidation((prevState) => ({
          ...prevState,
          billing_phone_number:
            "Please enter more than 6 and less than 16 digit phone number.",
        }));
        errorHandle = true;
      }
      if (!billingData?.billing_postal_zip) {
        document.getElementById("billing_postal_zip")?.focus();
        setInputValidation((prevState) => ({
          ...prevState,
          billing_postal_zip: "Please enter the postal zip.",
        }));
        errorHandle = true;
      }
      if (!billingData?.billing_address_1) {
        document.getElementById("billing_address_1")?.focus();
        setInputValidation((prevState) => ({
          ...prevState,
          billing_address_1: "Please enter the address line 1.",
        }));
        errorHandle = true;
      }
      if (!billingData?.billing_address_2) {
        document.getElementById("billing_address_2")?.focus();
        setInputValidation((prevState) => ({
          ...prevState,
          billing_address_2: "Please enter the address line 2.",
        }));
        errorHandle = true;
      }
      if (!billingData?.billing_city) {
        document.getElementById("billing_city")?.focus();
        setInputValidation((prevState) => ({
          ...prevState,
          billing_city: "Please enter the town/city.",
        }));
        errorHandle = true;
      }
      if (!billingData?.billing_country) {
        document.getElementById("billing_country")?.focus();
        setInputValidation((prevState) => ({
          ...prevState,
          billing_country: "Please choose the country/region.",
        }));
        errorHandle = true;
      }
      if (
        !billingData?.billing_state &&
        !billingData?.billing_state?.state_name
      ) {
        document.getElementById("billing_state")?.focus();
        setInputValidation((prevState) => ({
          ...prevState,
          billing_state: "Please enter the province/state.",
        }));
        errorHandle = true;
      }

      if (!errorHandle) {
        handleUpdateBilling();
      }
    }
  };

  return (
    <div className="checkout-container">
      {/* description */}
      <HeadDescription data={checkoutOrderSummary} />

      {/* stepper */}
      <Box sx={{ width: "100%" }} className="stepper-container">
        <Stepper
          nonLinear
          activeStep={activeStep.current}
          alternativeLabel
          connector={<QontoConnector />}
        >
          {steps.map((label, index) => (
            <Step key={label} completed={completed[index]}>
              <StepLabel StepIconComponent={QontoStepIcon}>{label}</StepLabel>
            </Step>
          ))}
        </Stepper>
      </Box>
      {/* steps using accordion */}
      <div className="accordion-container">
        {/* Contact Information Panel */}
        <div className="accordion">
          <div
            className="accordion-head"
            aria-controls="panel1d-content"
            id="panel1d-header"
            style={{
              backgroundColor: expanded === `panel1` ? "#F7F3ED" : "#f2f2f2",
            }}
          >
            <div className="section">
              <div className="top">
                {checkoutData?.email && <TickIcon />}
                <Typography>Contact information</Typography>
              </div>
              {checkoutData?.email && expanded !== "panel1" && (
                <div className="bottom">
                  <p className="detail">{checkoutData?.email}</p>
                  <p className="btn" onClick={() => handleChange("panel1")}>
                    Change
                  </p>
                </div>
              )}
            </div>
          </div>
          <div style={{ display: expanded === `panel1` ? "block" : "none" }}>
            <ContactUsInfo
              setContactData={setContactData}
              contactData={contactData}
              handleUpdate={handleUpdateContactForm}
              emailValidation={emailValidation}
              setEmailValidation={setEmailValidation}
            />
          </div>
        </div>
        <div className="accordion">
          <div
            className="accordion-head"
            aria-controls="panel2d-content"
            id="panel2d-header"
            style={{
              backgroundColor: expanded === `panel2` ? "#F7F3ED" : "#f2f2f2",
            }}
          >
            <div className="section">
              <div className="top">
                {checkoutData?.shipping_first_name && <TickIcon />}
                <Typography>Shipping address</Typography>
              </div>
              {checkoutData?.shipping_first_name && expanded !== "panel2" && (
                <div className="bottom">
                  <div>
                    <p className="detail">
                      {checkoutData?.shipping_first_name}{" "}
                      {checkoutData?.shipping_last_name}
                    </p>
                    <p className="detail">{checkoutData?.shipping_address_1}</p>
                    <p className="detail">
                      {checkoutData?.shipping_city},
                      {shippingData?.shipping_state?.state_name
                        ? shippingData?.shipping_state?.state_name
                        : shippingData?.shipping_state}
                      ,{shippingData?.shipping_country?.country_name},
                      {checkoutData?.shipping_postal_zip}
                    </p>
                  </div>
                  <p className="btn" onClick={() => handleChange("panel2")}>
                    Change
                  </p>
                </div>
              )}
            </div>
          </div>
          <div style={{ display: expanded === `panel2` ? "block" : "none" }}>
            <ShippingInfo
              shippingData={shippingData}
              setShippingData={setShippingData}
              handleUpdate={handleUpdateShippingAddress}
              shippingBilling="shipping"
              statetrigger={statetrigger}
            />
          </div>
        </div>
        <div className="accordion">
          <div
            className="accordion-head"
            aria-controls="panel3d-content"
            id="panel3d-header"
            style={{
              backgroundColor: expanded === `panel3` ? "#F7F3ED" : "#f2f2f2",
            }}
          >
            <div className="section">
              <div className="top">
                <Typography>Payment method</Typography>
              </div>
            </div>
          </div>
          {loading ? (
            Array.from({ length: 4 }, (_, index) => (
              <SkeletonLine
                key={index}
                style={{
                  height: "4vh",
                  margin: "10px",
                  width: "auto",
                  borderRadius: "2px",
                }}
              />
            ))
          ) : expanded === `panel3` &&
            checkoutPayment?.client_secret &&
            checkoutPayment?.publish_key ? (
            <>
              <div className="input-section check">
                {checkoutPayment?.client_secret &&
                checkoutPayment?.publish_key ? (
                  <StripPayment
                    clientSecret={checkoutPayment?.client_secret}
                    publish_key={checkoutPayment?.publish_key}
                    handleSubmitCall={handleSubmitCall}
                    setHandleSubmitCall={setHandleSubmitCall}
                  />
                ) : (
                  checkoutPayment?.message &&
                  !checkoutPayment?.status && (
                    <div
                      id="payment-message"
                      style={{
                        padding: "1rem 0.5rem 1rem 0.5rem",
                        color: "red",
                        fontSize: "12px",
                      }}
                    >
                      {checkoutPayment?.message}
                    </div>
                  )
                )}
                {checkoutPayment?.client_secret &&
                checkoutPayment?.publish_key ? (
                  <>
                    <p
                      style={{
                        paddingLeft: "8px",
                      }}
                    >
                      Billing to
                    </p>
                    <FormControlLabel
                      control={
                        <Checkbox
                          icon={<UnFilledCheckIcon />}
                          checkedIcon={<FilledCheckIcon />}
                          inputProps={{ "aria-label": "controlled" }}
                          checked={billedCheckbox}
                          onClick={() => {
                            setBilledCheckbox(!billedCheckbox);
                            setPostalCodeValid(null);
                          }}
                        />
                      }
                      label="Same as shipping address "
                    />
                    <div
                      style={{
                        display: !billedCheckbox ? "block" : "none",
                        width: "100%",
                      }}
                    >
                      <BillingInfo
                        billingData={billingData}
                        setBillingData={setBillingData}
                        setInputValidation={setInputValidation}
                        inputValidation={inputValidation}
                        setBillingStateTrigger={setBillingStateTrigger}
                        billingStatetrigger={billingStatetrigger}
                      />
                    </div>
                  </>
                ) : (
                  ""
                )}
              </div>
              <div
                style={{
                  display: "flex",
                  alignItems: "center",
                  padding: "2rem 0.5rem 1rem 0.5rem",
                  justifyContent: "center",
                }}
              >
                <Button
                  disabled={billingStatetrigger}
                  id="submit"
                  onClick={() => handleValidateInput()}
                  style={{
                    width: "100%",
                    maxWidth: "22.375rem",
                    textTransform: "none",
                    color: "#fff",
                    fontSize: "1rem",
                    fontWeight: 500,
                    minHeight: "3.0625rem",
                    backgroundColor: "#d25333",
                    outline: 0,
                    border: 0,
                    borderRadius: "4px",
                    fontFamily: "inherit",
                    opacity: billingStatetrigger ? "0.5" : 1,
                  }}
                >
                  Place order
                  {/* {isLoading ? (
                <CircularProgress
                  className="progress-circle"
                  style={{
                    color: "#ffffff",
                    width: "32px",
                    height: "32px",
                  }}
                />
              ) : (
                "Place order"
              )} */}
                </Button>
              </div>
            </>
          ) : null}
        </div>
      </div>
      {postalCodeValid ? (
        <div
          className="postal-code-valid"
          id="postal-code-isvalid"
          tabIndex={1}
        >
          <div>
            <svg
              width="19"
              height="17"
              viewBox="0 0 19 17"
              fill="none"
              xmlns="http://www.w3.org/2000/svg"
            >
              <path
                d="M9.47367 10.6093C9.532 10.7454 9.6292 10.8038 9.76529 10.8038C9.88193 10.8038 9.9597 10.726 10.0375 10.5899C10.1347 10.376 10.2708 9.73449 10.4263 8.68468C10.5818 7.61542 10.6596 6.79889 10.6596 6.21566C10.6596 5.12696 10.368 4.60205 9.76529 4.60205C9.14318 4.60205 8.85156 5.1464 8.85156 6.21566C8.85156 6.93498 8.94877 7.80983 9.1043 8.8402C9.25982 9.85114 9.37647 10.4538 9.47367 10.6093Z"
                fill="#FE0000"
                stroke="#FE0000"
                stroke-width="0.4"
              />
              <path
                d="M9.75339 11.6194C9.50066 11.6194 9.28681 11.7166 9.0924 11.911C8.89799 12.1054 8.80078 12.3193 8.80078 12.5914C8.80078 12.8442 8.89799 13.0775 9.07296 13.2524C9.26737 13.4468 9.48122 13.5441 9.75339 13.5441C10.0061 13.5441 10.2394 13.4468 10.4338 13.2524C10.6282 13.058 10.7254 12.8442 10.7254 12.5914C10.7254 12.3387 10.6282 12.1249 10.4338 11.9304C10.22 11.7166 10.0061 11.6194 9.75339 11.6194Z"
                fill="#FE0000"
                stroke="#FE0000"
                stroke-width="0.4"
              />
              <path
                d="M18.186 12.9228L11.8288 1.72479C11.4011 0.966586 10.6235 0.5 9.74861 0.5C8.87377 0.5 8.09613 0.947145 7.66843 1.72479L1.31122 12.9228C0.88352 13.681 0.902961 14.5753 1.33066 15.3141C1.75836 16.0529 2.536 16.5 3.41085 16.5H16.1058C16.9612 16.5 17.7389 16.0529 18.186 15.3141C18.5943 14.5753 18.6137 13.681 18.186 12.9228ZM17.4472 14.9058C17.1556 15.3919 16.6502 15.6835 16.0864 15.6835H3.41085C2.84706 15.6835 2.34159 15.3919 2.04998 14.9058C1.75836 14.4198 1.75836 13.8366 2.04998 13.3311L8.38774 2.13305C8.67936 1.62758 9.18482 1.33597 9.74861 1.33597C10.3124 1.33597 10.8373 1.62758 11.1095 2.13305L17.4472 13.3311C17.7389 13.8171 17.7389 14.4004 17.4472 14.9058Z"
                fill="#FE0000"
                stroke="#FE0000"
                stroke-width="0.4"
              />
            </svg>
          </div>
          <p>{postalCodeValid}</p>
        </div>
      ) : null}
      {/* orderSummary */}
      <OrderSummaryInfo
        data={checkoutOrderSummary}
        handleCallSubmit={handleValidateInput}
        billedCheckbox={billedCheckbox}
        billingData={billingData}
        billingStatetrigger={billingStatetrigger}
      />
    </div>
  );
};

export default Checkout;
